import * as mobx from 'mobx';
import * as IoC from 'typescript-ioc';
import { IntlShape } from 'react-intl';
import { IGetMeetingsRequestParams, IMeetingDetailsDTO, IMeetingFilterParams, IMeetingsDAO, MeetingStatusFilter } from '../../../../../../api/meetings.dao';
import { PagingViewModel } from '../../../../../global/_paging/paging-viewmodels/regular-paging.viewmodel';
import { IEventDetailsDTO } from '../../../../../../api/events.dao';
import { IErrorParsing } from '../../../../../../infrastructure/error-parsing';
import { alertServerError } from '../../../../../global/modal/alerts-host/alert-templates';

export const MAX_CHECKED_MEETINGS_COUNT = 20;
class MeetingsFilterViewModel {
    @mobx.observable
    public loading: boolean = false;
    @mobx.observable
    public meetingsList: IMeetingDetailsDTO[];
    @mobx.observable
    private paginationVM: PagingViewModel;
    @mobx.observable
    public selectedMeetings: IMeetingDetailsDTO[] = [];

    public constructor(
        public readonly accountId: number,
        private readonly event: IEventDetailsDTO,
        private readonly intl: IntlShape,
        @IoC.Inject private readonly errorParsing = IoC.Container.get(IErrorParsing),
        @IoC.Inject private readonly meetingsDAO: IMeetingsDAO = IoC.Container.get(IMeetingsDAO)
    ) {
        this.event = this.event;
        this.paginationVM = new PagingViewModel();
        mobx.reaction(this.paginationVM.getCurrentPage, this.getMeetingsList);
        this.paginationVM.setPageSize(20);
        this.getMeetingsList();
    }

    @mobx.action
    private getMeetingsList = async (): Promise<void> => {
        this.loading = true;
        const params: IMeetingFilterParams = {
            eventId: this.event.eventId,
            accountId: this.accountId,
            withoutRoom: true,
        };
        try {
            const response = await this.meetingsDAO.getEventMeetings({
                ...params as IGetMeetingsRequestParams,
                status: MeetingStatusFilter.SCHEDULED,
                withoutRoom: false,
                size: this.paginationVM.getPageSize(),
                page: this.paginationVM.getCurrentPageForBE(),
            });
            mobx.runInAction(() => {
                this.meetingsList = response.content;
            });
            this.paginationVM.setTotalRecords(response.totalElements);
        } catch (error) {
            const errorMessage = this.errorParsing.extractMessage(error);
            alertServerError('Error', errorMessage);
        } finally {
            mobx.runInAction(() => {
                this.loading = false;
            });

        }
    };

    public getEventTimezone(): string {
        return this.event.timeZone;
    }

    public getPaginationVM = () => {
        return this.paginationVM;
    };

    @mobx.action
    public getSelectedMeetings = (meetingIds: string[]): IMeetingDetailsDTO[] => {
        const setMeetings: Set<IMeetingDetailsDTO> = new Set();

        this.selectedMeetings.filter(selected => {
            if (meetingIds.includes(String(selected.meetingId))) {
                setMeetings.add(selected);
            }
        });

        this.meetingsList.filter(meeting => {
            if (meetingIds.includes(String(meeting.meetingId)) && !this.selectedMeetings.some(value => value.meetingId === meeting.meetingId)) {
                setMeetings.add(meeting);
            }
        });

        this.selectedMeetings = [...setMeetings];
        return this.selectedMeetings;

    };
}

export default MeetingsFilterViewModel;